// Toggle.tsx
import React from 'react';
import {css} from 'aphrodite';
import Styles from './Toggle.jss';

type ToggleProps = {
    value: boolean;
    onChange: (v: boolean) => void;
    label?: string;
    disabled?: boolean;
    id?: string;
};

export default function Toggle({value, onChange, label, disabled, id}: ToggleProps) {
    return (
        <label
            className={css(Styles.container)}
            htmlFor={id}
        >
            <span className={css(Styles.wrap)}>
                <input
                    id={id}
                    type="checkbox"
                    className={css(Styles.checkbox)}
                    checked={value}
                    onChange={e => onChange(e.target.checked)}
                    disabled={disabled}
                    role="switch"
                    aria-checked={value}
                />
                <span className={css(Styles.track)}>
                    <span className={css(Styles.knob)} />
                </span>
            </span>
            {label && <span className={css(Styles.text)}>{label}</span>}
        </label>
    );
}
